var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGainVisibility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60.52356 9.69059a1 1 0 0 0 -1.29607-.92051l-14.82756 4.60617a1 1 0 0 0 .02146 1.91637l4.33916 1.24211a1 1 0 0 1 .54009 1.54043l-11.65307 16.40734a1 1 0 0 1 -1.39434.23624l-13.86-9.84386a1 1 0 0 0 -1.39434.23624l-17.95054 25.274a1 1 0 0 0 .23624 1.39435l4.07647 2.89526a1 1 0 0 0 1.39435-.23624l13.89719-19.56699a1 1 0 0 1 1.39434-.23624l13.86 9.84386a1 1 0 0 0 1.39435-.23624l15.70642-22.11436a1 1 0 0 1 1.63237.00253l2.60215 3.688a1 1 0 0 0 1.81649-.611z",
    fill: "#6d6e71"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.523 9.65625a1.99865 1.99865 0 0 0 -2.5918-1.84082l-14.8282 4.60547a2.00029 2.00029 0 0 0 .043 3.833l4.33935 1.24218-11.65283 16.40724-13.85986-9.84277a1.99978 1.99978 0 0 0 -2.78907.47168l-17.95068 25.27343a2.00037 2.00037 0 0 0 .47266 2.78907l4.07714 2.89648a2.004 2.004 0 0 0 2.78809-.47363l13.897-19.56641 13.86081 9.84473a2.00294 2.00294 0 0 0 2.78809-.47363l15.70654-22.11527 2.602 3.68848a1.99971 1.99971 0 0 0 3.63282-1.22168z",
    fill: "#7cb342"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGainVisibility);
export default __webpack_public_path__ + "static/media/gain-visibility.7e0a012ece2dad3508397e6071a724cc.svg";
export { ForwardRef as ReactComponent };